var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BX_AEComposition"},[_c('div',{staticClass:"BX_Class1 BX_BG1 BX_Ani1",style:({backgroundImage: 'url('+_vm.mode[0]+')'})})])}
var staticRenderFns = []

export { render, staticRenderFns }